// =====================================================
// 设备/视口判断工具
// 全站统一以 768px 作为移动端断点，与 _variables.scss 的 $bp-md 保持一致。
// 注意：这里必须能在 new Vue() 之前同步取到结果，
// 否则首屏会先按桌面结构渲染一帧再切成移动端结构（视觉上的闪烁）。
// =====================================================

// 与 _variables.scss $bp-md 一致
export const MOBILE_BREAKPOINT = 768

// 当前视口是否属于移动端
export function isMobileViewport () {
  if (typeof window === 'undefined') return false
  const width = window.innerWidth || document.documentElement.clientWidth || 0
  return width > 0 && width < MOBILE_BREAKPOINT
}

// UA 判断（仅用于「是否触屏设备」这类兜底场景，布局判断一律用视口宽度）
export function isMobileUA () {
  if (typeof navigator === 'undefined') return false
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS/i.test(
    navigator.userAgent
  )
}

// 是否运行在微信内置浏览器（微信里没有浏览器地址栏，底部安全区表现也不同）
export function isWeChat () {
  if (typeof navigator === 'undefined') return false
  return /MicroMessenger/i.test(navigator.userAgent)
}

/**
 * 把视口状态同步进 vuex，并监听尺寸变化（含移动端横竖屏切换）
 * @param {import('vuex').Store} store
 */
export function initDeviceListener (store) {
  if (typeof window === 'undefined') return

  const sync = () => {
    const value = isMobileViewport()
    if (store.state.systemStore.isMobile !== value) {
      store.commit('systemStore/setIsMobile', value)
    }
  }

  // 首次同步：state 初始值已经是同步计算的，这里只是兜底
  sync()

  // resize 在移动端输入法弹起时会高频触发，做一层节流
  let timer = null
  const onResize = () => {
    if (timer) return
    timer = window.setTimeout(() => {
      timer = null
      sync()
    }, 150)
  }

  window.addEventListener('resize', onResize)
  window.addEventListener('orientationchange', sync)

  // 微信内置浏览器给 html 打标记，便于个别样式单独兜底
  if (isWeChat()) {
    document.documentElement.classList.add('in-wechat')
  }
}
